import { useEffect, useState } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  CssBaseline,
} from "@mui/material";
import CallRecordingsView from "./CallRecordingsView";
import SmartFloManagerList from "./SmartFloManagerList";
import CpSourcingTeamList from "./CpSourcingTeamList";
import { useDispatch, useSelector } from "react-redux";
import action from '../../Redux Store/actions';
import LeadsView from "./LeadsView";

// Original Tabs
const TABS = ["Sales Managers", "CP Sourcing Team", "Call Recordings", "SM Analytics"];

export default function Smartflo() {
  const [view, setView] = useState({ type: "list" });
  const [activeTab, setActiveTab] = useState(0);

  const loggedInUser = useSelector((state) => state?.Auth?.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(action.activeMenu('smartflo'));
  }, [dispatch]);

  console.log("loggedInUser", loggedInUser);

  // ✅ Role Check
  const isSalesManager =
    loggedInUser?.roleId?.title === "Sales Manager";
    console.log('isSalesManager', isSalesManager)

  // ✅ Filter Tabs based on role
  const filteredTabs = isSalesManager
    ? TABS.filter((tab) => tab !== "Sales Managers" && tab !== "CP Sourcing Team")
    : TABS;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <CssBaseline />

      {/* ── Main ── */}
      <Box component="main" sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>

        {/* ── Top AppBar ── */}
        <AppBar
          position="static"
          elevation={0}
          sx={{
            bgcolor: "background.paper",
            borderBottom: "1px solid",
            borderColor: "divider",
            color: "text.primary",
          }}
        >
          <Toolbar sx={{ justifyContent: "space-between", px: 3 }}>
            {/* Mirrors the Leads page title (.title in Leads.module.css):
                same values, and deliberately WITHOUT !important so the global
                div/.MuiTypography-root rule in App.css:198-202 overrides
                font-family, font-size and line-height here exactly as it does
                for Leads. Net effect: this renders at the same 1.6rem as every
                other tab's page title. font-weight and color are not set by
                that global rule, so they do apply — and they match Leads. */}
            <Typography
              sx={{
                fontFamily: "Roboto-Regular",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "3.2rem",
                lineHeight: "4rem",
                color: "#202124",
              }}
            >
              SmartFlo Integration
            </Typography>
          </Toolbar>
        </AppBar>

        {/* ── Content ── */}
        <Box sx={{ flexGrow: 1, p: 3 }}>

          {/* ── List View with Tabs ── */}
          {view.type === "list" && (
            <>
              {/* Tabs */}
              <Tabs
  value={activeTab}
  onChange={(_, newVal) => setActiveTab(newVal)}
  sx={{
    mb: 2,
    borderBottom: "1px solid #e5e7eb",

    "& .MuiTabs-indicator": {
      backgroundColor: "#2563eb",
      height: "2px",
      borderRadius: "2px",
    },

    "& .MuiTab-root": {
      textTransform: "none",
      fontSize: "14px",
      fontWeight: 500,
      color: "#6b7280",
      minHeight: 42,
      px: 2.5,
      transition: "all 0.2s ease",

      "&:hover": {
        color: "#111827",
      },
    },

    "& .Mui-selected": {
      color: "#2563eb !important",
      fontWeight: 600,
    },
  }}
>
  {filteredTabs.map((tab) => (
    <Tab key={tab} label={tab} disableRipple />
  ))}
</Tabs>


              {/* ✅ Tab Content (Using Tab Name — FIXED) */}
              
              {filteredTabs[activeTab] === "Sales Managers" && (
                <SmartFloManagerList
                 onViewLeads={(smId, smName) =>
  setView({ type: "leads", smId, smName })
}
                  onViewRecordings={(smId) =>
                    setView({ type: "recordings", smId })
                  }
                />
              )}

              {filteredTabs[activeTab] === "CP Sourcing Team" && (
                <CpSourcingTeamList />
              )}

              {filteredTabs[activeTab] === "Call Recordings" && (
                <CallRecordingsView
                  salesManagerId={null}
                  onBack={() => {}}
                />
              )}

              {filteredTabs[activeTab] === "SM Analytics" && (
                <Typography>SM Analytics Coming Soon</Typography>
              )}
            </>
          )}

 {/* ✅ LEADS VIEW (MOVE HERE) */}
  {view.type === "leads" && (
    <LeadsView
  salesManagerId={view.smId}
  smName={view.smName}   // 🔥 ADD THIS
  onBack={() => setView({ type: "list" })}
/>
  )}

  
          {/* ── Recordings View ── */}
          {view.type === "recordings" && (
            <CallRecordingsView
              salesManagerId={view.smId}
              onBack={() => setView({ type: "list" })}
            />
          )}

        </Box>
      </Box>
    </Box>
  );
}